<div class="total-loops-card">
    <div class="loops rounded" *ngFor="let shift of transferByShiftList">
        <p class="title-loops text-left">
            {{ typeProduction | uppercase }} {{ "shift_" | lang | uppercase }}
            {{ shift.shiftName }}
        </p>
        <p class="subtitle-loops text-right">{{ shift.totalLoopByShift }}</p>
    </div>
</div>
